import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { UploadProgressBar } from "src/ui/containers/dashboard/files/components/UploadProgressBar";
import { useFileUpload } from "src/ui/containers/dashboard/files/hooks/useFileUpload";
import { CustomAlert } from "src/ui/shared/CustomAlert/CustomAlert";
import { FileDropzone } from "src/ui/shared/form/FileDropzone";

import { useUploadContext } from "@dashboard/files/context/UploadContext";
import { Modal } from "@shared/Modal/Modal";

type Props = {
    groupId?: number;
    groupName?: string;
    open: boolean;
    onClose: () => void;
    disabled?: boolean;
    showProgressBar?: boolean;
    hint?: React.ReactNode;
};

export const FileUploadModal = ({ showProgressBar = true, ...props }: Props) => {
    const { t } = useTranslation(["modals", "common"]);
    const inputId = React.useId();
    const { uploadStarted } = useUploadContext();
    const { onFilesSelected } = useFileUpload({ groupId: props.groupId });

    return (
        <Modal open={props.open} onClose={props.onClose} title={t("modals:uploadFile.title")}>
            <FileDropzone
                inputId={inputId}
                label={
                    props.groupName ? (
                        <Trans
                            ns="common"
                            i18nKey="section.uploadField.dropzoneWithDestination"
                            values={{ destination: props.groupName }}
                            components={{ u: <u /> }}
                        />
                    ) : (
                        <Trans ns="common" i18nKey="section.uploadField.dropzone" components={{ u: <u /> }} />
                    )
                }
                caption={t("common:section.uploadField.maxSize")}
                multiple
                onFilesSelected={onFilesSelected}
                disabled={props.disabled || uploadStarted}
            />
            {props.hint ? <CustomAlert severity="info">{props.hint}</CustomAlert> : null}
            {showProgressBar && uploadStarted ? <UploadProgressBar /> : null}
        </Modal>
    );
};
